const Config = {
    apiUrl: process.env.REACT_APP_API_URL || "https://auth-api.fullstackdev.in",
    port: process.env.REACT_APP_PORT || 80,
};

export default Config;